import { IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';
import introspectionQueryResultData from './fragmentTypes';

/**
 * Get the GraphQL fragment matcher
 * @memberof module:@sm/utils
 * @returns {IntrospectionFragmentMatcher} IntrospectionFragmentMatcher
 */
export default function getGraphQLFragmentMatcher() {
  return new IntrospectionFragmentMatcher({
    introspectionQueryResultData
  });
}
